export const FETCH_PRODUCTS_DATA = 'FETCH_PRODUCTS_DATA';
export const FETCH_PRODUCTS_SUMMARY = 'FETCH_PRODUCTS_SUMMARY';
export const CREATE_PRODUCT = 'FETCH_PRODUCTS_SUMMARY';
export const UPDATE_PRODUCT = 'FETCH_PRODUCTS_SUMMARY';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const SEARCH_PRODUCT = 'FETCH_PRODUCTS_SUMMARY';
export const PRODUCT_FORM_INPUT = 'PRODUCT_FORM_INPUT';
export const PRODUCT_FORM_INPUT_ARRAY = 'PRODUCT_FORM_INPUT_ARRAY';
export const INPUT_IMAGE_FEATURE = 'INPUT_IMAGE_FEATURE';
export const INPUT_IMAGE_MULTIPLE = 'INPUT_IMAGE_MULTIPLE';
export const GET_PRODUCT_CATEGORIES = 'GET_PRODUCT_CATEGORIES';
export const GET_SINGLE_PRODUCT = 'GET_SINGLE_PRODUCT';
export const SET_SINGLE_PRODUCT = 'SET_SINGLE_PRODUCT';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_COVER_IMAGE_STATE = 'SET_COVER_IMAGE_STATE';
export const SET_GALLERY_IMAGE_STATE = 'SET_GALLERY_IMAGE_STATE';
export const RESET_PRODUCT_FORM = 'RESET_PRODUCT_FORM';
export const RESET_FEATURE_IMAGE = 'RESET_FEATURE_IMAGE';
export const PRODUCT_DOWNLOADABLE = 'PRODUCT_DOWNLOADABLE';
export const REMOVE_GALLERY_IMAGE = 'REMOVE_GALLERY_IMAGE';
